import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import*as echarts from 'echarts';
import * as socketApi from './request/socket';
import 'echarts-liquidfill';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import scroll from 'vue-seamless-scroll/src'

const app = createApp(App);
app.config.globalProperties.$echarts = echarts 
app.config.globalProperties.$http = axios;
app.config.globalProperties.$socketApi = socketApi;

app.config.devtools = true;


createApp(App).use(store).use(router).use(ElementPlus).use(scroll).mount('#app')

// const win = window

// if (process.env.NODE_ENV === 'development') {

//     if ('__VUE_DEVTOOLS_GLOBAL_HOOK__' in win) {

//         win.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app

//     }

// }